import { Card, Group, MantineSize, Text, ThemeIcon } from '@mantine/core'
import { TGetAlert } from 'api/alerts/getAlert'
import { useTranslation } from 'react-i18next'
import { TbArrowDownRight, TbArrowUpRight } from 'react-icons/tb'
import { TExceed } from 'shared/types'
import { ExceedChart } from './ExceedChart'

export const ExceedCard = ({
  stat,
  alert,
  deviceId,
}: {
  stat: TExceed
  alert: Omit<TGetAlert, 'exceeds'>
  deviceId: string
}) => {
  const { t } = useTranslation()
  const diff = Math.round(100 - (stat.value / stat.currentValue) * 100)

  return (
    <Card withBorder p="md">
      <ExceedHeader {...stat} />
      <ExceedChart
        deviceId={deviceId}
        //@ts-ignore
        indicator={stat?.indicator?.code}
        exceedValue={stat?.value}
        alert={alert}
      />
      <Text c="dimmed" fz="sm" mt="md">
        {t('alert.valueExceededBy')}{' '}
        <Text component="span" c={diff < 20 ? undefined : 'red'} fw={700}>
          {diff}%
        </Text>
      </Text>
    </Card>
  )
}

export const ExceedHeader = ({
  size = 32,
  disableIcon = false,
  ...stat
}: TExceed & { size?: number | MantineSize; disableIcon?: boolean }) => {
  const { t } = useTranslation()

  const DiffIcon =
    stat.mathSymbol === '>' || stat.mathSymbol === '≥'
      ? TbArrowUpRight
      : TbArrowDownRight

  return (
    <Group justify="space-between">
      <div>
        <Text c="dimmed" tt="uppercase" fw={700} fz="xs">
          {t(`indicator.${stat?.indicator?.code}`)}
        </Text>
        <Text c="red" fz={size} fw={700}>
          {stat.currentValue.toFixed(2)} {stat?.indicator?.unit}
        </Text>
      </div>
      {disableIcon ? null : (
        <ThemeIcon
          color="gray"
          variant="light"
          style={{ color: 'var(--mantine-color-red-6)' }}
          size={38}
          radius="md"
        >
          <DiffIcon size="1.8rem" />
        </ThemeIcon>
      )}
    </Group>
  )
}
